/**
 * Override Drug — field-level effects.
 *
 * Migrated from: manage/override-drug.coffee
 *
 * Old validators → new effects:
 *   SetLogoURl → SetLogoURl
 *
 * Skipped:
 *   handle(dfd) init logic — no runtime init needed
 */
import { buildApiUrl, fetchAPI } from "@neu/libui";
import type { FieldHandler } from "@neu/libui";

// ─── SetLogoURl ────────────────────────────────────────────────────────────
// Old: DSLFx.Validators.SetLogoURl
// Trigger field: pharmacy
// Fetches the selected pharmacy and copies its logo URL into logo_pharmacy.
export const SetLogoURl: FieldHandler = (field, { form }) => {
	void (async () => {
		const pharmacyId = field.value;
		if (!pharmacyId) return;

		try {
			const data = await fetchAPI(buildApiUrl(`/pharmacy/${pharmacyId}`));
			const pharm = Array.isArray(data) ? data[0] : data;
			if (!pharm) return;

			form.setFieldState("logo_pharmacy", (s) => {
				s.value = pharm.logo || "";
			});
		} catch (err) {
			console.error("SetLogoURl: API error", err);
		}
	})();
	return "";
};
